import usePDPContext from './usePDPContext';

const DEFAULT_VALUE = {};

const usePDPOptions = () => usePDPContext()?.productOptions ?? DEFAULT_VALUE;

export default usePDPOptions;
